<script setup lang="ts">
import { hero } from '../../../content'
</script>

<template>
  <section id="hero" class="hero">
    <div class="container">
      <div class="hero__content">
        <span class="hero__eyebrow animate animate--fade-up">
          {{ hero.eyebrow }}
        </span>

        <h1 class="hero__title animate animate--fade-up animate--delay-1">
          {{ hero.headline.split('\n')[0] }}
          <br>
          <span>{{ hero.headline.split('\n')[1] }}</span>
        </h1>

        <p class="hero__description animate animate--fade-up animate--delay-2">
          {{ hero.subheadline }}
        </p>

        <div class="hero__actions animate animate--fade-up animate--delay-3">
          <a
            v-for="btn in hero.buttons"
            :key="btn.label"
            :href="btn.href"
            :class="btn.style === 'stroke' ? 'btn btn--white-outline btn--lg' : 'btn btn--white btn--lg'"
          >
            {{ btn.label }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>
